import { render } from "./MobileVideoDetail.vue?vue&type=template&id=24bf32ee&scoped=true"
import script from "./MobileVideoDetail.vue?vue&type=script&lang=js"
export * from "./MobileVideoDetail.vue?vue&type=script&lang=js"

import "./MobileVideoDetail.vue?vue&type=style&index=0&id=24bf32ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bf32ee"]])

export default __exports__